import { jsx as _jsx } from "react/jsx-runtime";
import { useThemeConfig } from "../themeConfigContext";
import { GridSection } from "./gridSection";
export function HeaderLayoutSection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Header",
                    label: t("LBL_HEADER", { ns: "Administration" }) || "Header",
                },
                {
                    title: "Header logo",
                    label: t("LBL_HEADER_LOGO", { ns: "Administration" }) || "Header logo",
                },
            ],
            [
                {
                    title: "Header user",
                    label: t("LBL_HEADER_USER", { ns: "Administration" }) || "Header user",
                },
            ],
        ] }));
}
export function MainMenuLayoutSection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Menu north",
                    label: t("LBL_MENU_NORTH", { ns: "Administration" }) || "Menu north",
                    margin: true,
                },
                {
                    title: "Menu south",
                    label: t("LBL_MENU_SOUTH", { ns: "Administration" }) || "Menu south",
                    margin: true,
                },
            ],
            [
                {
                    title: "Menu east",
                    label: t("LBL_MENU_EAST", { ns: "Administration" }) || "Menu east",
                    margin: true,
                },
                {
                    title: "Menu west",
                    label: t("LBL_MENU_WEST", { ns: "Administration" }) || "Menu west",
                    margin: true,
                },
            ],
        ] }));
}
export function DockLayoutSection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Dock north",
                    label: t("LBL_DOCK_NORTH", { ns: "Administration" }) || "Dock north",
                    margin: true,
                },
                {
                    title: "Dock south",
                    label: t("LBL_DOCK_SOUTH", { ns: "Administration" }) || "Dock south",
                    margin: true,
                },
            ],
            [
                {
                    title: "Dock east",
                    label: t("LBL_DOCK_EAST", { ns: "Administration" }) || "Dock east",
                    margin: true,
                },
                {
                    title: "Dock west",
                    label: t("LBL_DOCK_WEST", { ns: "Administration" }) || "Dock west",
                    margin: true,
                },
            ],
        ] }));
}
export function DrawerLayoutSection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Drawer north",
                    label: t("LBL_DRAWER_NORTH", { ns: "Administration" }) || "Drawer north",
                    margin: true,
                },
                {
                    title: "Drawer south",
                    label: t("LBL_DRAWER_SOUTH", { ns: "Administration" }) || "Drawer south",
                    margin: true,
                },
            ],
            [
                {
                    title: "Drawer east",
                    label: t("LBL_DRAWER_EAST", { ns: "Administration" }) || "Drawer east",
                    margin: true,
                },
                {
                    title: "Drawer west",
                    label: t("LBL_DRAWER_WEST", { ns: "Administration" }) || "Drawer west",
                    margin: true,
                },
            ],
        ] }));
}
export function MainContentLayoutSection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Main",
                    label: t("LBL_MAIN", { ns: "Administration" }) || "Main",
                },
            ],
        ] }));
}
export function FooterLayoutSection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Footer",
                    label: t("LBL_FOOTER", { ns: "Administration" }) || "Footer",
                },
                {
                    title: "Footer logo",
                    label: t("LBL_FOOTER_LOGO", { ns: "Administration" }) || "Footer logo",
                },
            ],
            [
                {
                    title: "Footer settings",
                    label: t("LBL_FOOTER_SETTINGS", { ns: "Administration" }) ||
                        "Footer settings",
                },
            ],
        ] }));
}
